import React, { useEffect, useRef } from "react";
import { formatDateDetails } from "../exports/functions";
import LightGallery from "lightgallery/react";
import lgThumbnail from "lightgallery/plugins/thumbnail";
import lgZoom from "lightgallery/plugins/zoom";
import { Link } from "react-router-dom";

const GalleryViewSction = (props) => {
  const { id, galleryImagesData, setSubBreadcrumbTitle } = props;

  const galleryGridRef = useRef(null);
  const images = galleryImagesData?.map((data) => {
    return {
      id: data?.id,
      Name: data?.name,
      Date: data?.date,
      image: data?.images?.map((img) => img?.media?.url),
    };
  });
  const filteredGallery = images.find((img) => img.id === id);
  const formatedDate = formatDateDetails(filteredGallery?.Date || "");
  useEffect(() => {
    if (id !== undefined) {
      galleryGridRef.current?.scrollIntoView({ behavior: "smooth" });
      setSubBreadcrumbTitle(filteredGallery?.Name);
    }
  }, [filteredGallery?.Name, id, setSubBreadcrumbTitle]);
  return (
    <section className="gallery py-120" ref={galleryGridRef}>
      <div className="container">
        <div className="container">
          <div className="section-heading text-center">
            {/* <div className="flex-align d-inline-flex gap-8 mb-16">
              <span className="text-main-600 text-2xl d-flex">
                <i className="ph-bold ph-book-open" />
              </span>
              <h5 className="text-main-600 mb-0">
                {galleryHeaderData[0]?.attributes?.Snippet}
              </h5>
            </div> */}
            <h2 className="mb-24">{filteredGallery?.Name}</h2>
            <p className="">{formatedDate?.Full_Date}</p>
          </div>
          {/* <div className="text-center">
                <div
                  className="nav-tab-wrapper bg-white border border-neutral-40 p-16 mb-40 d-inline-block"
                  data-aos="zoom-out"
                >
                  <ul
                    className="nav nav-pills common-tab edit gap-16"
                    id="pills-tab"
                    role="tablist"
                  >
                    <li className="nav-item" role="presentation">
                      <button
                        className="nav-link rounded-pill bg-main-25 text-md fw-medium text-neutral-500 flex-center w-100 gap-8 active"
                        id="pills-education-tab"
                        data-bs-toggle="pill"
                        data-bs-target="#pills-education"
                        type="button"
                        role="tab"
                        aria-controls="pills-education"
                        aria-selected="true"
                      >
                        <i className="text-xl d-flex text-main-600 ph-bold ph-squares-four" />
                        Online Education
                      </button>
                    </li>
                    <li className="nav-item" role="presentation">
                      <button
                        className="nav-link rounded-pill bg-main-25 text-md fw-medium text-neutral-500 flex-center w-100 gap-8"
                        id="pills-University-tab"
                        data-bs-toggle="pill"
                        data-bs-target="#pills-University"
                        type="button"
                        role="tab"
                        aria-controls="pills-University"
                        aria-selected="false"
                      >
                        <i className="text-xl d-flex text-main-600 ph-bold ph-magic-wand" />
                        University
                      </button>
                    </li>
                    <li className="nav-item" role="presentation">
                      <button
                        className="nav-link rounded-pill bg-main-25 text-md fw-medium text-neutral-500 flex-center w-100 gap-8"
                        id="pills-Tutors-tab"
                        data-bs-toggle="pill"
                        data-bs-target="#pills-Tutors"
                        type="button"
                        role="tab"
                        aria-controls="pills-Tutors"
                        aria-selected="false"
                      >
                        <i className="text-xl d-flex text-main-600 ph-bold ph-code" />
                        Tutors
                      </button>
                    </li>
                  </ul>
                </div>
              </div> */}
          <div className="tab-content" id="pills-tabContent">
            <div
              className="tab-pane fade show active"
              id="pills-education"
              role="tabpanel"
              aria-labelledby="pills-education-tab"
              tabIndex={0}
            >
              {/* Masonry Start */}
              <div className="masonry">
                <LightGallery speed={500} plugins={[lgThumbnail, lgZoom]}>
                  {filteredGallery?.image?.map((image, index) => (
                    <Link
                      to={image && `${process.env.REACT_APP_cmsUrl}${image}`}
                      key={index}
                      className="masonry__item position-relative rounded-12 overflow-hidden"
                      style={{ display: "block" }}
                    >
                      <img
                        alt={`Image-${index + 1}`}
                        src={image && `${process.env.REACT_APP_cmsUrl}${image}`}
                      />
                    </Link>
                  ))}
                </LightGallery>
              </div>
              {/* Masonry End */}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default GalleryViewSction;
